import { render } from "./Na.vue?vue&type=template&id=0646440a"
import script from "./Na.vue?vue&type=script&lang=js"
export * from "./Na.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__